import { render } from "./StoresRevenueByMedium.vue?vue&type=template&id=c0fdc3c8&scoped=true"
import script from "./StoresRevenueByMedium.vue?vue&type=script&lang=js"
export * from "./StoresRevenueByMedium.vue?vue&type=script&lang=js"

import "./StoresRevenueByMedium.vue?vue&type=style&index=0&id=c0fdc3c8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fdc3c8"]])

export default __exports__